module.exports = __webpack_public_path__ + "img/plus.483e3829.svg";